import Global from 'global';
import React from 'react';
import { Q, QLocalStorage } from "js/quantum";
import "css/main.scss";

export class UserLogin extends React.Component {
    constructor() {
        super();
        this.state = {
            email: QLocalStorage.getItem('loginName') || '',
            pass: '',
            remember: true,
            ajaxing: false,
        };
        this._refEmail = null;
        this._refPass = null;
        this._autoFocusInput = this.state.email ? 'pass' : 'email';
    }

    componentDidMount() {
        if (this.state.email) {
            this._refPass.focus();
        } else {
            this._refEmail.focus();
        }
    }

    handleChange(evt) {
        const value = evt.target.type === 'checkbox' ? evt.target.checked : evt.target.value;
        this.setState({ [evt.target.name]: value });
    }

    login(evt) {
        evt.preventDefault();
        this.setState({ ajaxing: true });
        Q.post('/auth/login', { json: this.state })
        .done(() => {
            QLocalStorage.setItem('loginName', this.state.email);
            location.href = this.props.location.query.next_url || '/';
        })
        .fail(() => {
            this._refPass.focus();
            this.setState({ pass: '' });
        })
        .always(() => {
            this.setState({ ajaxing: false });
        })
        ;
    }

    render() {
        return (
            <div id="login-page">
                <div className="login-header">
                    <div className="logo-wrapper">{ Global.config.loginLogoName }</div>
                    <div className="sys-name-wrapper">{ Global.config.loginSystemName }</div>
                </div>
                <div className="login-body">
                    <form id="login-form" className="" onSubmit={this.login.bind(this)}>
                        <div className="form-row">
                            <input
                                type="txt" name="email" className="form-control"
                                placeholder="用户名" required
                                value={this.state.email}
                                onChange={this.handleChange.bind(this)}
                                disabled={this.state.ajaxing}
                                ref={(c) => { this._refEmail = c; }} key="email"
                            />
                        </div>
                        <div className="form-row">
                            <input
                                type="password" name="pass" className="form-control" required
                                placeholder="密码"
                                value={this.state.pass} onChange={this.handleChange.bind(this)}
                                disabled={this.state.ajaxing}
                                ref={(c) => { this._refPass = c; }} key="pass"
                            />
                        </div>
                        <div className="form-row">
                            <label className="checkbox-inline" >
                                <input
                                    type="checkbox" name="remember" checked={this.state.remember}
                                    onChange={this.handleChange.bind(this)}
                                />
                                <span>记住我</span>
                            </label>
                        </div>
                        <div className="form-row">
                            <button
                                className="btn btn-primary btn-lg" type="submit"
                                disabled={this.state.ajaxing}
                            >登录</button>
                            <div className="forget-pass hide">
                                <a href="#" data-action="forget-pass">
                                忘记密码
                            </a>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./js/user/login.jsx